
namespace RioERP.Products {
    export class ProductBooksColumns {
        static columnsKey = 'Products.ProductBooks';
    }
}